module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-6",
      "lang": "en-US"
    }
  }, [_vm._v("CHAPTER TWO")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The first time Mila Kinslow finally broke down and cried was in Amarillo, Texas.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She had taken a seat alone at a picnic table underneath the eave of a rundown truck stop, listlessly chewing the crust off a stale bologna sandwich and counting what remained of the fifteen dollars she had set aside. Mila had tried hard not to think too much about her mother, especially how she hadn’t even had the presence of mind or decency to kiss the poor dead woman on the forehead before she’d fled the house. Now she found she could no longer blink back the tears that had begun to well behind her eyes. Uncharitable thoughts about the doctor, the police, hell, the whole damned uncaring town lit off inside her head like electrical sparks. It made her feel as though she was shrinking down to nothing. Mila knew nobody would be looking for her, just like nobody would be there to stand graveside when her momma’s body was finally lowered into that black valley soil.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The drone of Amarillo traffic hummed on the overpass and the evening air smelled of asphalt, overheated rubber, and car exhaust. Mila pulled the collar of her sweater tight around her neck, and shivered even though the night was warm. The sandwich tasted like chalk dust in her mouth, and she noticed that the creepy-looking man was staring at her again through the flyspecked cashiers’ window. The horn-rimmed glasses that rested crookedly on his nose reflected blue and green neon from the menu board, the planes of his face a moonscape of scars from a childhood disease. His attention felt like unwashed fingers on her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What the hell you lookin’ at, Bubba?” she called out, and he slid his eyes away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She hadn’t spoken ten words since the bus had pulled out of the terminal in Tennessee, and the sound of her own voice resonated strangely to her. Her heartbeat felt constricted, like it was squeezed inside a fist, and tiny pinpricks of darkness crowded the edges of her vision.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mila hadn’t been aware that she had begun to weep. She swiped her cheeks with the sleeve of a stretched-out sweater and threaded her way between the tables toward the restroom as the bus driver sounded a five-minute warning on the horn. Her chest ached when she breathed, her throat raw and swollen from crying. She stepped inside the women’s room, ran cold water in a porcelain sink, and cupped her hands beneath the tepid water, splashing it on her face. She dried off with a paper towel, waiting for some kind of signal, any kind of hopeful sign, from the misshapen image that stared back from the mirror that was bolted to the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She made a wish, and waited for her reflection to slide right off the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sunrise arrived in soft focus the next morning, composed of warm pastels and gentle edges, and painted elongated shadows of white fir and lodgepole pine across the highway. Mila had leaned her head against the window and fallen asleep somewhere outside of Glenrio, Texas, and hadn’t awakened until she felt the bus pull off the interstate. She stretched the kinks out of her neck as the driver announced their imminent arrival in Flagstaff.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her mouth was dry and tasted foul from the sandwich she had eaten hours earlier. She briefly considered getting off the bus to buy something to eat, but knew she couldn’t really spare the cost. Instead she reached into the rucksack she carried and searched in vain for a stick of gum, or anything that might push the hunger pangs away. She was disappointed that the pastel sunrise had already disappeared. Never in her life had she felt so alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mila turned her attention to the passengers who had been sitting across the aisle. She watched them as they stood and tugged backpacks and parcels wrapped in brown paper tied with twine out of the storage space overhead. A rush of cool morning desert air swept along the aisle as the pneumatic doors sighed open, and she pressed her palm against the window to gauge the temperature outside. A susurrus of muted conversation and the shuffling of feet filled in the empty spaces as new passengers filed aboard, and she allowed her mind to drift as a single line of lacy clouds was carried by the wind across a blanched dome of sky.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Anybody sitting here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The voice that startled Mila belonged to a young woman.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mila gave the girl a glance, shrugged, and moved the rucksack off the unoccupied seat and placed it on the floor. Except for the unexpected burst of emotion she’d succumbed to in Amarillo, the trip had mostly been a long, slow-moving picture of depressing nothingness. So, the truth was, a seat-mate might be a welcome distraction.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Name’s Alexandra,” the girl said, and pushed a lock of hair behind her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay,” Mila said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mila judged that the girl named Alexandra couldn’t be much older than twenty, and though the expression in her eyes was soft, she possessed an air of circumspection that hinted at experience beyond her years. She wore a look of kindness and compassion that put Mila in mind of the images of angels rendered in colored panes of glass inside the arched windows at the church that she and Momma sometimes attended back at home.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is the part where you tell me "), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("your")]), _vm._v(" name,” Alexandra said, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mila?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Without warning, Mila felt herself swept up again by a sudden sense of isolation. She felt herself floating away, abandoned and forsaken, though she knew it had nothing to do with Alexandra.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Was that a question?” Alexandra said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Heat rushed to Mila’s face and she sensed herself on the brink of losing her composure. She felt certain that this girl must think she was insane. Mila felt like she was disappearing, her fingers clawing an empty space beside her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aw, sweetheart, hush now. Don’t cry,” Alexandra whispered, and looked into Mila’s eyes as though she had seen inside her mind. “You’re not just a name badge pinned to your sweater.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2d31ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504081696-6.vue
// module id = 90
// module chunks = 0